import { esIphone } from './plataforma';

/**
 * Impedir que la app de iPhone amplíe la pantalla al tocar un campo de texto.
 *
 * iOS hace zoom por su cuenta cuando el texto del campo mide menos de 16 px, y casi todos los
 * nuestros miden 14. En Safari es una molestia; dentro de la app deja la pantalla ampliada y, en un
 * diálogo, corta su borde derecho y el botón de cerrar (visto en «Invita y gana»).
 *
 * Se limita la escala en la etiqueta `viewport`, que es lo que iOS consulta. Solo en la app de
 * iPhone: en la web el zoom es del usuario y no se toca, y en Android el problema no existe. El
 * zoom con dos dedos no se pierde por esto: Capacitor ya lo desactiva en su WebView.
 */
export const evitarZoomAlEscribir = (): void => {
	if (!esIphone()) {
		return;
	}

	const meta = document.querySelector('meta[name="viewport"]');
	if (!meta) {
		return;
	}

	const contenido = meta.getAttribute('content') ?? '';
	if (contenido.includes('maximum-scale')) {
		return;
	}

	meta.setAttribute('content', [contenido, 'maximum-scale=1'].filter(Boolean).join(', '));
};
